import { render, staticRenderFns } from "./etusivu.vue?vue&type=template&id=420785e6&scoped=true&"
import script from "./etusivu.vue?vue&type=script&lang=ts&"
export * from "./etusivu.vue?vue&type=script&lang=ts&"
import style0 from "./etusivu.vue?vue&type=style&index=0&id=420785e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420785e6",
  null
  
)

export default component.exports